import * as Blockly from 'blockly/core';
import 'blockly/python';
//import { getAllowedOutputs } from './strata_compatibility_checks';

Blockly.Blocks['globe_interactive_map_viz'] = {
    init: function() {
      this.appendDummyInput()
          .appendField(new Blockly.FieldDropdown([
            ["bitmap", "bitmap"],
            ["heatmap", "heatmap"],
            // ["choropleth maps", "choropleth"],
            // ["Gauge", "gauge"],
            // ["stacked bar chart", "barchart"],
          ]), "charttype");
      // this.appendValueInput("vis_params")
      //     .setCheck(null)
      //     .setVisible(false);
      this.setInputsInline(true);
      this.setPreviousStatement(true, null);
      this.setNextStatement(true, null);
      this.setColour('#53565a');
      this.setStyle("dashboards")
      this.setTooltip("");
      this.setHelpUrl("");
    },

}